export enum CoverageProductType {
  Returns = "returns",
  PackageProtection = "package_protection",
  FinalSale = "final_sale",
}
